import React, { useEffect } from 'react'
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchCounts } from '../../redux/slices/siteDetailSlice';

const UnitCountOne = () => {

    const dispatch = useDispatch();
    const { counts, loading } = useSelector((state) => state.siteDetail);

    useEffect(() => {
        dispatch(fetchCounts());
    }, [dispatch]);

    return (
        <div className="row row-cols-xxxl-5 row-cols-lg-3 row-cols-sm-2 row-cols-1 gy-4">
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-1 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">Total Users</p>
                                <h6 className="mb-0">{counts.users || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-cyan rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="gridicons:multiple-users"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* card end */}
            </div>
            <div className="col">
                <div className="card shadow-none border bg-gradient-start-2 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Total Servicmen
                                </p>
                                <h6 className="mb-0">{counts.servicemen?.total || 0}</h6>
                            </div>
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Verfied Servicmen
                                </p>
                                <h6 className="mb-0 text-primary">{counts.servicemen?.verified || 0}</h6>
                            </div>
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Unverfied Servicmen
                                </p>
                                <h6 className="mb-0 text-danger">{counts.servicemen?.unverified || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-purple rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="fa-solid:award"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* card end */}
            </div>

            <div className="col">
                <div className="card shadow-none border bg-gradient-start-3 h-100">
                    <div className="card-body p-20">
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                            <div>
                                <p className="fw-medium text-primary-light mb-1">
                                    Total Service Categories
                                </p>
                                <h6 className="mb-0">{counts.categories || 0}</h6>
                            </div>
                            <div className="w-50-px h-50-px bg-info rounded-circle d-flex justify-content-center align-items-center">
                                <Icon
                                    icon="fluent:people-20-filled"
                                    className="text-white text-2xl mb-0"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/* card end */}



            </div>


        </div>

    )
}

export default UnitCountOne